import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { Groups, Props as WidgetProps } from './Groups';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../_partials/WidgetBoxWide';
import getStatLine from '../../../utils/getStatLine';
import EmptyState from '../../EmptyState';
import { URLS } from '@wix/da-url';
import GroupsConfigPopover from './GroupsConfigPopover';

import s from './Groups.scss';

class GroupsBoxWide extends React.Component<
  WidgetProps &
    WidgetBoxWideProps &
    WithTranslation & {
      totalCount?: number;
      isOwner: boolean;
      profileOwnerUser: PapiUser;
    }
> {
  render() {
    const {
      id,
      subHeader,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      totalCount,
      hasMore,
      fetchMore,
      isFetching,
      isEmpty,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      parentRef,
      widgetBoxClassName,
      section,
      zone,
      ...props
    } = this.props;
    const { t, type, moduleId, profileOwnerUser, isOwner } = props;

    return (
      <WidgetBoxWide
        section={section}
        zone={zone}
        id={id}
        header={t(`widgets.groups_${type}.header`)}
        count={totalCount}
        subHeader={getStatLine(t, 'groups', totalCount)}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        hasMore={hasMore}
        fetchMore={fetchMore}
        isFetching={isFetching}
        moduleId={moduleId}
        widgetMoveUp={widgetMoveUp}
        parentRef={parentRef}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        widgetMenuRenderer={close => (
          <GroupsConfigPopover moduleId={moduleId} onClose={close} />
        )}
        className={widgetBoxClassName}
        isEmpty={isEmpty}
        emptyView={
          isOwner ? (
            <EmptyState
              view="small"
              className={classnames(s['empty-state'], s['is-owner'], s[type])}
              title={t(`widgets.groups_${type}.empty.title.owner`)}
              subtitle={t(`widgets.groups_${type}.empty.subtitle.owner`)}
              buttonLabel={t(`widgets.groups_${type}.empty.CTALabel.owner`)}
              withButton={true}
              onButtonClick={this.navigateToBrowseGroups}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              titleClassName={s['empty-state-title']}
              title={t(`widgets.groups_${type}.empty.title.visitor`, {
                username: profileOwnerUser.username,
              })}
              subtitle={t(`widgets.groups_${type}.empty.subtitle.visitor`, {
                username: profileOwnerUser.username,
              })}
            />
          )
        }
      >
        <Groups {...props} isWide />
      </WidgetBoxWide>
    );
  }

  navigateToBrowseGroups() {
    window.location.replace(URLS.GROUPS);
  }
}

export default withTranslation()(GroupsBoxWide) as React.ComponentType<
  Pick<
    WidgetBoxWideProps,
    | 'moduleId'
    | 'id'
    | 'isHeaderStickyOnMobile'
    | 'subHeader'
    | 'headerExtraElementsOnMobile'
  >
>;
